// UploadTradesController
app.controller('UploadTradesController', ['$scope', 'WdHttpService', 'analyticsService',
    function($scope, WdHttpService, analyticsService) {
        // Init 
        $scope.init = async function() {
            $scope.hideUpdateBtn = false;
            await $scope.fetchAdviserSiteDetails();
            $scope.showPageLoader();
            var user_profile = await WdHttpService._cognito_profile(false);
            if (!$scope.checkIsUserBrokerOffline()) {
                $scope.showErrorPopup("You are not allowed to access this page, this page is only for Users who trade offline.", () => window.location.href = '/wealthbaskets');
                return;
            } else {
                $scope.brokerName = getProfileValueFor('custom:brokerName1', user_profile);
            }

            WdHttpService._get_offline_trades()
                .then(response => {
                    if (response.pendingDetails) {
                        //clone the server response and then assignment is required to be done
                        $scope.pendingStocksToTrade = JSON.parse(JSON.stringify(response.pendingDetails));
                        $scope.pendingStocksToTradeUserCopy = JSON.parse(JSON.stringify(response.pendingDetails));

                        $scope.pendingStocksToTradeUserCopy.forEach(obj => {
                            obj['orders'].forEach(order => {
                                order['price'] = 0;
                            })
                        });

                        if ($scope.pendingStocksToTradeUserCopy.length > 0) $scope.activeCollapse = $scope.pendingStocksToTradeUserCopy[0]['fundName'];
                    } else {
                        $scope.pendingStocksToTrade = [];
                        $scope.pendingStocksToTradeUserCopy = [];
                    }

                    $scope.hidePageLoader();
                })
                .catch(error => {
                    $scope.hidePageLoader();
                    $scope.showErrorPopup(error);
                });
        }

        $scope.downloadTradeList = function(data, filename) {
            var csvData = [];
            data.forEach(order => {
                var rowData = [];
                rowData.push(order.symbol);
                rowData.push(order.description);
                rowData.push(order.exchange);
                rowData.push(order.orderSide);
                rowData.push(order.quantity);
                csvData.push(rowData);
            })
            $scope.downloadUploadTradesListCSVFile(csvData, filename);
        }

        $scope.downloadUploadTradesListCSVFile = async function(orders, filename) {
            var headerString = 'symbol,stockName,exchange,orderType,quantity\r\n';
            createCSVAndDownload(orders, headerString, filename);
            var eventData = {
                'fileName': filename.toLowerCase()
            };
            await analyticsService._push_custom_event_data_to_datalayer('trade-file-downloaded', eventData);
        }

        $scope.collapse = function(fundName) {
            if ($scope.activeCollapse == fundName)
                $scope.activeCollapse = undefined;
            else
                $scope.activeCollapse = fundName;
        }

        $scope.submitTrades = function(fundName) {
            var fundTrades = $scope.pendingStocksToTradeUserCopy.find(obj => obj.fundName == fundName);
            $scope.serverTrades = $scope.pendingStocksToTrade.find(obj => obj.fundName == fundName);

            $scope.confirmedOrders = [];
            $scope.rejectedOrders = [];
            var isValid = true;
            for (let index = 0; index < fundTrades.orders.length; index++) {
                const userOrder = fundTrades.orders[index];
                const serverOrder = $scope.serverTrades.orders[index];
                //validation
                if (userOrder.quantity > 0 && userOrder.price <= 0) {
                    $scope.showErrorPopup(userOrder.description + ' price cannot be zero or less than zero. Please rectify the issue and resubmit.');
                    isValid = false;
                    break;
                }

                if (userOrder.quantity > serverOrder.quantity) {
                    $scope.showErrorPopup(userOrder.description + ' quantity is incorrect, You have entered more qty than required. Please rectify the issue and resubmit.');
                    isValid = false;
                    break;
                }
            }

            if (isValid == false)
                return;

            for (let index = 0; index < fundTrades.orders.length; index++) {
                const order = fundTrades.orders[index];
                const requiredOrder = $scope.serverTrades.orders[index];

                var update = [];
                update.push(fundTrades.clientCode);
                update.push(fundTrades.requestId);
                update.push(order.symbol);
                update.push(order.exchange);
                update.push(order.quantity); //4
                update.push(order.price);
                update.push(order.orderSide);
                if (order.quantity == requiredOrder.quantity) {
                    $scope.confirmedOrders.push(update);
                } else if (order.quantity > 0) {
                    $scope.confirmedOrders.push(update);
                    // update[4] = Math.abs(order.quantity - requiredOrder.quantity); //Show the partial Qty as rejected Order.
                    // $scope.rejectedOrders.push(update);
                } else {
                    $scope.rejectedOrders.push(update);
                }
            }

            // show the modal
            $("#confirmTrades").modal("show");
            $scope.confirmationForFundName = fundName;
        }

        $scope.uploadTradeFile = function() {
            $scope.showPageLoader();
            // Code reference from https://stackoverflow.com/questions/14964035/how-to-export-javascript-array-info-to-csv-on-client-side
            let csvContent = "";
            csvContent += 'clientCode,requestId,symbol,exchange,quantity,price,orderSide\r\n';
            $scope.confirmedOrders.forEach(function(rowArray) {
                let row = rowArray.join(",");
                csvContent += row + "\r\n";
            });

            $scope.rejectedOrders.forEach(function(rowArray) {
                if (rowArray[4] == 0) {
                    let row = rowArray.join(",");
                    csvContent += row + "\r\n";
                }
            });

            // console.log(csvContent);
            const csvFile = btoa(csvContent);
            // const csvFile = "data:text/csv;charset=utf-8," + btoa(csvContent);
            // console.log(csvFile);
            WdHttpService._upload_offline_trades(csvFile)
                .then(async response => {
                    $scope.hidePageLoader();
                    $scope.pendingStocksToTrade = $scope.pendingStocksToTrade.filter(obj => obj['fundName'] != $scope.confirmationForFundName);
                    $scope.pendingStocksToTradeUserCopy = $scope.pendingStocksToTradeUserCopy.filter(obj => obj['fundName'] != $scope.confirmationForFundName);
                    if ($scope.pendingStocksToTrade.length > 0) {
                        $scope.showSuccessPopup("Your trades are updated successfully");
                    } else {
                        $scope.showSuccessPopup("Your trades are updated successfully", () => { window.location.href = '/my-portfolio'; });
                    }
                    await analyticsService._push_custom_event_data_to_datalayer('trades-updated-successfully', {});

                }).catch(error => {
                    console.log(error);
                    $scope.showErrorPopup(error);
                    $scope.hidePageLoader();
                });
            // hide the modal
            $("#confirmTrades").modal("hide");
        }

        $scope.autoFillQty = function(fundName) {
            var serverTrades = $scope.pendingStocksToTrade.find(obj => obj.fundName == fundName);

            $scope.pendingStocksToTradeUserCopy.filter(obj => obj['fundName'] == fundName).forEach(fund => {
                for (let index = 0; index < fund.orders.length; index++) {
                    fund.orders[index].quantity = serverTrades.orders[index].quantity;
                }
            })
        }

        $scope.getStockOrginalQty = function(symbol) {
            const order = $scope.serverTrades.orders.find(stock => stock.symbol == symbol);
            return order.quantity;
        }
    }
]);